import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { messages } from '../../../messages';
export const RetryAction = handler => ({
  id: 'try-again',
  promise: async () => handler(),
  text: /*#__PURE__*/React.createElement(FormattedMessage, messages.try_again)
});